import { render, staticRenderFns } from "./DescargoCerPage.vue?vue&type=template&id=3cdae845"
import script from "./DescargoCerPage.js?vue&type=script&lang=js&external"
export * from "./DescargoCerPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports